import { render, staticRenderFns } from "./sidebar-item-link.vue?vue&type=template&id=17051953&"
import script from "./sidebar-item-link.vue?vue&type=script&lang=ts&"
export * from "./sidebar-item-link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports